import React from 'react';
import { Main } from './components/containers/Main';

const ImportHistory = () => <Main />;

export default ImportHistory;
